import { render, staticRenderFns } from "./pot-vehicle-create.vue?vue&type=template&id=210418c4"
import script from "./pot-vehicle-create.vue?vue&type=script&lang=js"
export * from "./pot-vehicle-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports